import { CouponType } from 'types/coupon'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseTimestamp, FirebaseWriteBatch } from 'firebase/index'
import { getExpiredDate } from 'reducks/coupon/operations'
import { CouponUserType } from 'types/coupon_user'
import { push } from 'connected-react-router'

const deliveryCouponToAllUsers = (coupon: CouponType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    // ユーザーIDの取得
    const userIds = await db
      .collection('users')
      .get()
      .then((snapshots) => {
        const ids: string[] = []
        snapshots.forEach((snapshot) => {
          ids.push(snapshot.id)
        })
        return ids
      })
      .catch((error) => {
        console.error(error)
        return []
      })
    // 500件以上のbatch処理に対応できるように
    const batchArray: FirebaseWriteBatch[] = []
    batchArray.push(db.batch())
    let operationCounter = 0
    let batchIndex = 0
    const ref = db.collection('coupons').doc(coupon.coupon_id).collection('coupon_users')
    const now = FirebaseTimestamp.now()
    const expiresDate =
      coupon.expires_at || coupon.expires_maxage
        ? getExpiredDate(coupon.expires_at || undefined, coupon.expires_maxage || 0)
        : undefined
    // 全ユーザー分のcoupon_usersを作成
    for (let i = 0; i < userIds.length; i = (i + 1) | 0) {
      const userId = userIds[i]
      const couponUser: CouponUserType = {
        user_id: userId,
        status: 'unused',
        created_at: now,
      }
      if (expiresDate) couponUser.expires_at = FirebaseTimestamp.fromDate(expiresDate)
      batchArray[batchIndex].set(ref.doc(userId), couponUser, { merge: true })
      operationCounter++
      if (operationCounter === 499) {
        batchArray.push(db.batch())
        batchIndex++
        operationCounter = 0
      }
    }
    // batch実行
    await batchArray.forEach((batch) => batch.commit())
    dispatch(hideLoadingAction())
    dispatch(push('/admin/coupon/list/complete'))
  }
}

export default deliveryCouponToAllUsers
